<template>
    <div class="page bg-gray page-flex" style="padding-bottom: 0;">
        <appStatus :statusHeight="statusHeight"></appStatus>
        <div class="page-input-title" :style="{top:statusHeight+'rem'}">
            <div class="alifont icon-back left-icon click" @click="back"></div>
            <input type="search" @keyup.13="handleQuery" class="center-input fs-28" placeholder="搜索订单号" v-model="pageInfo.orderNo">
            <div class="right fs-28 color-333 click" @click="handleQuery">
                搜索
            </div>
        </div>
<!--        <div class="page-state">-->
<!--            <van-tabs v-model="tabActive" swipeable :swipe-threshold="5" :line-width="'.6rem'" @click="tabClick">-->
<!--                <van-tab :title="item.title" :name="item.value" v-for="(item,$index) in tabList" :key="$index"></van-tab>-->
<!--            </van-tabs>-->
<!--        </div>-->
        <div class="flex1 posi-rel">
            <scroller ref="scroller" :on-refresh="loadNewData" :on-infinite="loadMore">
                <ul class="pt-10">
                    <li v-for="(item,$index) in data" :key="$index" class="flex-center" >
                        <div class="alifont pl-20 fs-48" :class="item.selected?'icon-xuanzhong color-main':'icon-weixuanzhong color-999'" @click="chooseOrder(item,$index)"></div>
                        <div class="order-item flex1 ofh" @click="getScrollerPosition();$router.push({name:'orderDetail',query:{orderId: item.orderId}})">
                            <div class="">
                                <div class="flex-center address-box">
                                    <div class="alifont icon-dizhi"></div>
                                    <div class="flex1">
                                        <div class="fs-28 color-333">{{item.userAddress}}</div>
                                        <div class="flex fs-28 color-999 mt-5">
                                            <div class="mr-30">{{item.userName}}</div>
                                            <div>{{item.userMobile}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-between fs-28 pd-250 bd-top" v-if="item.transportTime">
                                <div class="color-999">期望送达时间</div>
                                <div class="color-main">{{item.transportTime}}</div>
                            </div>

                            <div class="product-list">
                                <div v-if="item.productList.length == 1">
                                    <div class="product-item flex-center pd-100" v-for="(prod,prodIndex) in item.productList" :key="prodIndex" >
                                        <div class="product-img"><img :src="prod.imgPathView" alt=""></div>
                                        <div class="product-info flex1 ofh">
                                            <div class="fs-24 color-000 text-el mt-5">{{prod.productName}}</div>
                                            <div class="fs-22 color-999 mt-5" v-if="prod.specName">{{prod.specName}}</div>
                                            <div class="flex-between fs-24 color-999 mt-8">
                                                <div>¥{{prod.salePrice}}</div>
                                                <div>x{{prod.productQty}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex-between flex-center" v-else>
                                    <div class="product-item-img-box flex-center">
                                        <div class="product-img mr-10" v-for="(prod,prodIndex) in item.productList" :key="prodIndex" v-if="prodIndex<4">
                                            <img :src="prod.imgPathView" alt="">
                                        </div>
                                    </div>
                                    <div class="fs-24 color-999">共{{item.productList.length || 0}}件</div>
                                </div>
                            </div>
                            <div class="pd-250 fs-28 color-999">
                                <div class="flex-center flex-between fs-26">
                                    <div>订单号：{{item.orderNo}}</div>
                                    <div class="color-main">{{ getOrderStatusName(item.orderStatus) }}</div>
                                </div>
                                <div class="flex-center flex-between fs-26" v-if="item.wayUseOrderVO">
                                    <div>寄存货道：{{ item.wayUseOrderVO.orderShopName + '货道' + item.wayUseOrderVO.wayName}}</div>
                                </div>
                                <div class="mt-8 flex-between fs-26">
                                    <div>下单时间：{{new Date(item.orderCommitTime.replace(/-/g, '/')).Format('MM-dd hh:mm')}}</div>
                                    <div>合计：<span class="color-333">¥{{item.receivable}}</span></div>
                                </div>
                                <div class="fs-26 flex-between mt-8" v-if="item.dmMobile || item.dmName">
                                    <div>配送员：<span class="color-333">{{item.dmName}}</span></div>
                                    <div @click.stop="makeCall(item.dmMobile)">联系方式：<span class="color-333">{{item.dmMobile}}</span></div>
                                </div>
                                <div class="mt-8 bd-top pt-25 " v-if="item.remark">备注：<span class="color-333">{{item.remark}}</span></div>
                            </div>
                        </div>
                    </li>
                </ul>
            </scroller>
        </div>
        <div class="com-fixed-bot">
            <div class="flex-center flex1 click" @click="chooseAll()">
                <div class="alifont fs-48" :class="isChooseAll?'icon-xuanzhong color-main':'icon-weixuanzhong color-999'"></div>
                <div class="fs-30 color-333 ml-20">全选</div>
            </div>
            <div class="btn gray click" @click="print">打印订单</div>
            <div class="btn green click" @click="changeState">已送达</div>
        </div>
    </div>
</template>

<script>
    import initData from "@/mixins/initData"
    import routerBack from "@/mixins/routerBack"
    import initDict from '@/mixins/initDict'
    import appStatus from "@/components/appStatus/index"
    import getAppStatusHeight from "@/mixins/getAppStatusHeight";
    import printOrder  from "@/mixins/printOrder";
    import { batchUpdateOrderStatus } from "@/api/order"
    import config from "@/config"
    export default {
        name: "orderList",
        mixins: [initData,routerBack,initDict,getAppStatusHeight,printOrder],
        components:{appStatus},
        data(){
            return {
                tabList:[
                    {title:'待送达',value:'1'},
                    {title:'已寄存',value:'2'},
                ],
                tabActive: '1',
                shopId: this.$store.state.user.shopId,
                isChooseAll:false,
                orderType:null,
                aliasName:this.$store.state.aliasName || config.projectName
            }
        },
        created(){
            // 加载数据字典
            let codeList = [
                'orderStatus',
            ]
            this.getThisDict(codeList)
        },
        methods:{
            back(){
                if(this.isBackClose){
                    try{
                        window.native.onFinish();
                    }catch (e) {

                    }
                }else{
                    try{
                        window.native.onBack();
                    }catch (e) {
                        this.$router.go(-1)
                    }
                }
            },
            getOrderStatusName(status) {
                const list = this.dicts.orderStatus || [];
                const found = list.find(d => String(d.code) === String(status));
                return found ? found.codename : '';
            },
            beforeInit() {
                //
                this.params = { page : this.page, limit: this.limit,shopId:this.shopId,orderStatusIn:'3,7',orderType:this.orderType};
                this.url = 'order/orderBase/list';
                let query = this.pageInfo;
                for (var key in query){
                    if(query[key]){
                        this.params[key] = query[key]
                    }
                }
                return true
            },
            //切换状态
            tabClick(name){
                switch (name) {
                    case '1':
                        this.orderType = null;
                        break;
                    case '2':
                        this.orderType = 5;
                        break;
                }
                this.handleQuery();
            },

            //选择订单
            chooseOrder(data,$index){
                this.$set(this.data[$index],'selected',!this.data[$index].selected);
                this.judgeIsChooseAll();
            },

            //全选
            chooseAll(){
                this.isChooseAll = true;
                this.data.forEach(item=>{
                    this.$set(item,'selected',true)
                })
            },
            //判断是否已全选
            judgeIsChooseAll(){
                let bol = true;
                this.data.forEach(item=>{
                   if(!item.selected){
                       bol = false;
                       return
                   }
                })
                this.isChooseAll = bol;
            },

            loadMore(done) {
                setTimeout(() => {
                    if (this.noDate) {
                        this.$refs.scroller.finishInfinite(true);
                    } else {
                        this.page++;//下拉一次页数+1
                        this.isChooseAll = false;
                        this.init(done);
                    }
                }, 200);

            },


            //已送达
            changeState(){
                let array = [];
                this.data.forEach(item=>{
                    if(item.selected){
                        array.push(item);
                    }
                })
                if(array.length == 0){
                    this.$toast('请选择订单');
                    return
                }else{
                    let _this = this;
                    this.$dialog.alert({
                        title: "提示",
                        message: "确定此订单已送达？",
                        showCancelButton: true
                    })
                        .then(() => {     //点击确认按钮后的调用
                            let params = {
                                orderIds: array.map(item=>{
                                    return item.orderId
                                }).join(","),
                                orderStatus: 1
                            }
                            batchUpdateOrderStatus(params).then(res=>{
                                _this.$toast('操作成功');
                                _this.handleQuery();
                            })
                        })
                        .catch(() => { //点击取消按钮后的调用
                            console.log("cancel")
                        })

                }
            },

            //发货订单（只修改订单状态为待收货）
            sendOrder(){
                let array = [];
                this.data.forEach(item=>{
                    if(item.selected){
                        array.push(item);
                    }
                })
                if(array.length == 0){
                    this.$toast('请选择要打印订单');
                    return
                }else{
                    let _this = this;
                    this.$dialog.alert({
                        title: "提示",
                        message: "确定此订单发货？",
                        showCancelButton: true
                    })
                        .then(() => {     //点击确认按钮后的调用
                            let params = {
                                orderIds: array.map(item=>{
                                    return item.orderId
                                }).join(","),
                                orderStatus: 3
                            }
                            batchUpdateOrderStatus(params).then(res=>{
                                _this.$toast('操作成功');
                                _this.handleQuery();
                            })
                        })
                        .catch(() => { //点击取消按钮后的调用
                            console.log("cancel")
                        })
                }
            },
        },
        beforeRouteEnter(to, from, next) {
            if ( from.name == 'orderDetail') {
                to.meta.isBack = true;
            } else {
                to.meta.isBack = false;
            }
            next();
        },
        activated() {
            if (!this.$route.meta.isBack) {
                if(this.hasAlive){
                    this.handleQuery();
                }
            }
            this.$route.meta.isBack = false;
        },
    }
</script>

<style scoped lang="scss">
    .page-state{
        top: .9rem;
    }
    .fs-48{
        font-size: .48rem;
    }
    .order-item{
        margin: .1rem .24rem ;
        background: #fff;
        padding: 0 .24rem;
        border-radius: .12rem;
        .product-img{
            width: 1rem;
            height: 1rem;
            margin-right: .24rem;
        }
        .name{
            height: .8rem;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
        }
    }
    .btn-group{
        padding: .18rem 0;
        display: flex;
        justify-content: flex-end;
        .btn{
            width: 1.64rem;
            height: .56rem;
            text-align: center;
            line-height: .56rem;
            background: #fff;
            border-radius: .12rem;
            font-size: .26rem;
            color: $main-color;
            margin-left: .2rem;
            border: .01rem solid $main-color;
            &.active{
                background: $main-color;
                color: #fff;
            }
        }
    }
    .address-box{
        padding: .24rem 0;
        .alifont{
            font-size: .68rem;
            color: $main-color;
            margin-right: .1rem;
        }
    }

    .com-fixed-bot{
        height: .98rem;
        background: #fff;
        padding: .11rem .24rem;
        display: flex;
        align-items: center;
        .btn{
            width: 2.4rem;
            height: 100%;
            text-align: center;
            line-height: .76rem;
            border-radius: .12rem;
            margin-left: .24rem;
            font-size: .3rem;
            &.gray{
                background: #F4F4F4;
                color: $main-color;
            }
            &.green{
                background: $main-color;
                color: #fff;
            }
        }
    }

    .product-list{
        background: #FAFAFA;
        border-radius: .08rem;
        padding: .16rem;
    }
</style>



// WEBPACK FOOTER //
// waitFinishOrderList.vue?3c17b712